import { formatarCNPJ } from '../../shared/functions/validarCNPJ';

interface Props {
  value: number | string;
}

const formatarCPF = (value: number | string) => {
  const cpf = String(value).replace(/\D/g, '').slice(0, 11);

  if (cpf.length <= 3) return cpf;
  if (cpf.length <= 6) return `${cpf.slice(0, 3)}.${cpf.slice(3)}`;
  if (cpf.length <= 9) return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6)}`;

  return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9)}`;
};

const CpfCnpjFormatter = ({ value }: Props) => {
  const cleanValue = String(value).replace(/[^a-zA-Z0-9]+/g, '');
  const formattedValue = cleanValue.length > 11 ? formatarCNPJ(value) : formatarCPF(value);

  return <>{formattedValue}</>;
};

export default CpfCnpjFormatter;
